import axios from "axios";
 

export const listProductCategory = async () => {
  return await axios.get(process.env.REACT_APP_API + "/product-category");
};